import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const ContactForm = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      mobileno: "",
      email: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(15, "Must be 15 characters or less")
        .matches(/^[A-Za-z ]*$/, "Please enter valid name")
        .required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      mobile: Yup.string()
        .min(10, "Must be 10 characters")
        .max(10, "Must be 10 characters ")
        .matches(
          /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
          "Phone number is not valid"
        )
        .required("Required"),
      message: Yup.string()
        .max(200, "Must be 200 characters or less")
        .min(2, "Must be 20 characters or less")
        .required("Required"),
    }),
    onSubmit: (values) => {
      console.log(values);
    },
  });
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "16x",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "#1459BA",
          }}
        >
          Reach out to Us for Query or Suggestions!!!
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                id="name"
                label="Name"
                name="name"
                variant="outlined"
                fullWidth
                onChange={formik.handleChange}
                value={formik.values.name}
              />
              {formik.errors.name && formik.touched.name ? (
                <span style={{ color: "red" }}>{formik.errors.name}</span>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                id="email"
                label="Email"
                name="email"
                variant="outlined"
                fullWidth
                type={"email"}
                value={formik.values.email}
                onChange={formik.handleChange}
              />
              {formik.touched.email && formik.errors.email ? (
                <span style={{ color: "red" }}>{formik.errors.email}</span>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                id="mobile"
                label="Mobile"
                name="mobile"
                variant="outlined"
                type={"number"}
                fullWidth
                value={formik.values.mobile}
                onChange={formik.handleChange}
              />
              {formik.touched.mobile && formik.errors.mobile ? (
                <span style={{ color: "red" }}>{formik.errors.mobile}</span>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                id="message"
                label="Message"
                name="message"
                variant="outlined"
                fullWidth
                maxRows={4}
                inputProps={{
                  style: {
                    height: "81px",
                  },
                }}
                value={formik.values.message}
                onChange={formik.handleChange}
              />
              {formik.touched.message && formik.errors.message ? (
                <span style={{ color: "red" }}>{formik.errors.message}</span>
              ) : null}
            </Grid>
          </Grid>
          <Grid sx={{ pt: "16px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                backgroundColor: "#1459BA",
                borderRadius: "23px",
                width: "136px",
                height: "46px",
              }}
            >
              Submit
            </Button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default ContactForm;
